module.exports = __webpack_public_path__ + "img/1down.fdad3263.png";